import React from 'react';
import {
  Box
} from '@chakra-ui/react';
import BasePageComponent from "views/admin/components/base/BasePageComponent";

const RedemptionListPage = () => {

  const keyMappings = {
    given_name: 'Given Name',
    surname: 'Surname',
    email: 'Email',
    redemption_code: 'Redemption Code',
    redeemed_at: 'Redeemed At',
    status: 'Status',
  };

  const tableHeaders = [
    'given_name',
    'surname',
    'email',
    'redemption_code',
    'redeemed_at',
    'status',
  ];

  return (
    <Box width="100%" maxWidth="100vw" overflowX="hidden">
      <BasePageComponent
        txt="Redemption Records"
        showToggleView={false}
        tableName='coupon_redemption_list'
        tableHeaders={tableHeaders}
        keyMappings={keyMappings}
        showPagination={true}
        showAddIcon={false}
        showActions={false}
      />
    </Box>
  );
};

export default RedemptionListPage;